// get all blog posts
export const postsQuery = `*[_type == "post" && (isArchived == false || !defined(isArchived))]{
    _id,
    title,
    slug,
    date,
    tags[]->{
      _id,
      title,
      slug
    },
    body
}`

// get a single post by its slug
export const postQuery = `*[_type == "post" && (isArchived == false || !defined(isArchived)) && slug.current == $slug][0]{
    _id,
    title,
    slug,
    date,
    tags[]->{
      _id,
      title,
      slug
    },
    body
}`